import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
export default (function (props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $tick = _ref.$tick,
      $update = _ref.$update,
      $el = _ref.$el;
  var sum_rows = [],
      rows = [],
      current_thoc = 0;
  var thismonth = moment().format('YYYY-MM');
  var lastmonth = moment().subtract(1, 'M').format('YYYY-MM');
  var used_rows;
  var table = 'kho_thoc';

  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var rs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Base.call({
              method: '_findAll',
              table: table,
              params: {
                where: 'deleted_at IS NULL AND id_emp IS NULL AND id_mau IS NULL'
              }
            });

          case 2:
            rs = _context.sent;
            used_rows = rs.rows;
            $update();

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();

  var monthSelect = function monthSelect(e) {
    $f7.dialog.create({
      title: 'Chọn tháng',
      verticalButtons: true,
      buttons: [{
        text: 'THÁNG NÀY',
        onClick: function onClick() {
          $(e.target).text('THÁNG NÀY');
          getData(thismonth);
        }
      }, {
        text: 'THÁNG TRƯỚC',
        onClick: function onClick() {
          $(e.target).text('THÁNG TRƯỚC');
          getData(lastmonth);
        }
      }]
    }).open();
  };

  var getData = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(month) {
      var rs;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Base.call({
                method: 'get_data',
                route: 'KhoThoc',
                params: {
                  month: month
                }
              });

            case 2:
              rs = _context2.sent;
              sum_rows = rs.sum_rows;
              rows = rs.rows;
              $update();

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getData(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var getCurrent = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var rs;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Base.call({
                method: 'get_current',
                route: 'KhoThoc',
                params: {}
              });

            case 2:
              rs = _context3.sent;
              current_thoc = rs.total;
              $update();

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function getCurrent() {
      return _ref4.apply(this, arguments);
    };
  }();

  getData(thismonth);
  getCurrent();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="kho-thoc">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"></div>
        <div class="title sliding">Kho thóc Hà Xinh</div>
        <div class="right"></div>
      </div>
    </div>
    <div class="page-content">

      <div class="block text-align-center">
        <div>Số thóc hiện thời</div>
        <h3>${Utils.num2Str(current_thoc)} hạt</h3>
      </div>

      <div class="block-title text-align-center">DANH SÁCH <a @click="${monthSelect}">THÁNG NÀY</a></div>

      <div class="block-title">Tổng hợp</div>

      <div class="card data-table margin-half">
        <table>
          <thead>
            <tr>
              <th width="1%">STT.</th>
              <th>Người góp</th>
              <th class="numeric-cell">Tổng góp</th>
            </tr>
          </thead>
          <tbody>
            ${sum_rows.length > 0 && sum_rows.map((row,index)=>$h`
              <tr>
                <td>${index+1}.</td>
                <td>${row.name}</td>
                <td class="numeric-cell">${row.total}</td>
              </tr>
            `)}
          </tbody>
        </table>
      </div>

      <div class="block-title">Danh sách chi tiết</div>

      <div class="card data-table margin-half">
        <table>
          <thead>
            <tr>
              <th width="1%">STT.</th>
              <th>Người góp</th>
            </tr>
          </thead>
          <tbody>
            ${rows.length > 0 && rows.map((row,index)=>$h`
              <tr>
                <td>${index+1}.</td>
                <td>
                  <div>${row.name}</div>
                  <div style="margin-bottom: 10px;">${row.mo_ta}</div>
                  <div style="display: flex; justify-content: space-between;">
                    <div style="font-size: 11px;">${moment(row.created_at).format('D/M/YYYY HH:mm')}</div>
                    <div>${row.so_thoc}</div>
                  </div>
                </td>
              </tr>
            `)}
          </tbody>
        </table>
      </div>

      <div class="block-title">Lịch sử dùng thóc</div>

      <div class="card data-table margin-half">
        <table>
          <thead>
            <tr>
              <th>Mục đích sử dụng</th>
              <th class="numeric-cell">Số thóc</th>
            </tr>
          </thead>
          <tbody>
            ${used_rows && used_rows.map(row=>$h`
              <tr>
                <td>
                  <div>${row.note}</div>
                  <div>${moment(row.created_at).format('D/M/YYYY HH:mm')}</div>
                </td>
                <td class="numeric-cell">${row.so_thoc}</td>
              </tr>
            `)}
          </tbody>
        </table>
      </div>

    </div>
  </div>
`
    }
    ;
});